import { styled } from '@mui/material/styles'
import Container, { ContainerProps } from '@mui/material/Container'

const StyledContainer = styled(Container)<ContainerProps>(() => ({
  '@media (min-width: 1020px)': {
    paddingLeft: '110px !important',
    paddingRight: '110px !important',
  },
}))

export default StyledContainer
